export const internshipActionTranslations = {
  lv: {
    menu: 'Prakses darbības',
    sections: {
      internship: 'Prakse',
      delete: 'Dzēšana',
      downloads: 'Lejupielādes',
    },
    actions: {
      edit: 'Labot praksi',
      editGroups: 'Labot grupas',
      changeProgram: 'Mainīt programmu',
      changeQA: 'Mainīt anketu',
      setAgreementTemplate: 'Piešķirt līguma sagatavi',
      removeAgreementTemplate: 'Noņemt līguma sagatavi',
      deleteAllRecords: 'Dzēst visus dienasgrāmatas ierakstus',
      deleteAllOrgAnswers: 'Dzēst visas uzņēmumu anketu atbildes',
      downloadSummary: 'Lejupielādēt kopsavilkumu (XLSX)',
      downloadSupervisors: 'Lejupielādēt prakses vadītāju sarakstu (XLSX)',
    },
    fields: {
      title: 'Nosaukums',
      start: 'Sākums',
      end: 'Beigas',
      categories: 'Kategorijas',
    },
    validation: {
      title: 'Ievadiet prakses nosaukumu',
      start: 'Norādiet sākuma datumu',
      end: 'Norādiet beigu datumu',
      categories: 'Izvēlieties vismaz vienu kategoriju',
      template: 'Izvēlieties veidni',
      agreementTemplate: 'Izvēlieties līguma sagatavi',
    },
    groups: {
      current: 'Prakses grupas',
      currentHint:
        'Noņemiet atzīmi, lai grupu noņemtu no prakses — tās studentu prakses vietas tiks dzēstas. Bloķētu grupu noņemt nevar (beigusies prakses vieta, prakses vadītājs uzņēmumā, līgums vai anketas atbildes).',
      locked: 'Nevar noņemt',
      add: 'Pievienot grupas',
      year: 'Gads',
      allYears: 'Visi gadi',
      search: 'Meklēt',
      searchPlaceholder: 'Grupas nosaukums…',
      none: 'Nav grupu',
      cut: 'Rāda {{shown}} no {{total}} — precizējiet meklēšanu',
      chosen: 'Paliek: {{keep}} · pievienot: {{add}}',
      saveHint:
        'Saglabājot visām atzīmētajām grupām pievieno arī studentus, kuri vēl nav šajā praksē.',
    },
    templates: {
      currentProgram: 'Pašreizējā programma',
      currentQA: 'Pašreizējā anketa',
      pickProgram: 'Jaunā programma',
      pickQA: 'Jaunā anketa',
      none: 'nav',
      placeholder: 'Izvēlieties veidni',
      hintProgram:
        'Prakse saņem izvēlētās veidnes kopiju. Praktikanti, kuru prakse beigusies pirms labošanas perioda, paliek pie līdzšinējās programmas; pārējie pāriet uz jauno. Praktikanti ar savu programmu netiek mainīti.',
      hintQA:
        'Prakse saņem izvēlētās veidnes kopiju. Praktikanti, kuru prakse beigusies pirms labošanas perioda, paliek pie līdzšinējās anketas (viņu atbildes saglabājas); pārējie pāriet uz jauno.',
    },
    agreementTemplate: {
      current: 'Pašreizējais līguma numurs',
      pick: 'Līguma sagatave',
      search: 'Meklēt pēc nosaukuma vai prefiksa',
      none: 'Nav aktīvu līguma sagatavju',
      hint: 'Var izvēlēties tikai aktīvu sagatavi. Praktikanti ar savu sagatavi netiek mainīti; esošie līgumi saglabā savus numurus.',
    },
    confirm: {
      removeAgreementTemplate:
        'Noņemt līguma sagatavi praksei „{{title}}” (pašreizējais līguma numurs: {{number}})? Turpmāk izveidotie līgumi saņems numuru pēc prakses līguma nosaukuma. Esošie līgumi netiek mainīti.',
      deleteAllRecords:
        'Dzēst VISUS dienasgrāmatas ierakstus praksē „{{title}}”? Tiek dzēsti to praktikantu ieraksti, kuru prakse vēl ir labošanas periodā. Praktikantu progress tiek pārrēķināts, praktikanti saņem paziņojumu. Darbību nevar atsaukt.',
      deleteAllOrgAnswers:
        'Dzēst VISAS uzņēmumu anketu atbildes praksē „{{title}}”? Tiek dzēstas to praktikantu atbildes, kuru prakse vēl ir labošanas periodā. Atbildējušie prakses vadītāji un praktikanti saņem paziņojumu. Darbību nevar atsaukt.',
    },
    messages: {
      updated: 'Prakse saglabāta',
      groupsSaved: 'Grupas saglabātas',
      programChanged: 'Programma nomainīta',
      qaChanged: 'Anketa nomainīta',
      agreementTemplateSet: 'Līguma sagatave piešķirta',
      agreementTemplateRemoved: 'Līguma sagatave noņemta',
      recordsDeleted: 'Dzēsto ierakstu skaits: {{deleted}}, praktikanti: {{interns}}',
      answersDeleted: 'Dzēsto atbilžu skaits: {{deleted}}, praktikanti: {{interns}}',
      failed: 'Neizdevās saglabāt',
      loadFailed: 'Neizdevās ielādēt datus',
      downloadError: 'Neizdevās lejupielādēt datni',
    },
    files: {
      downloadSummary: 'kopsavilkums',
      downloadSupervisors: 'vaditaji',
    },
    save: 'Saglabāt',
    delete: 'Dzēst',
    remove: 'Noņemt',
  },
  en: {
    menu: 'Internship actions',
    sections: {
      internship: 'Internship',
      delete: 'Deletion',
      downloads: 'Downloads',
    },
    actions: {
      edit: 'Edit internship',
      editGroups: 'Edit groups',
      changeProgram: 'Change program',
      changeQA: 'Change survey',
      setAgreementTemplate: 'Assign agreement template',
      removeAgreementTemplate: 'Remove agreement template',
      deleteAllRecords: 'Delete all diary records',
      deleteAllOrgAnswers: 'Delete all company survey answers',
      downloadSummary: 'Download summary (XLSX)',
      downloadSupervisors: 'Download supervisor list (XLSX)',
    },
    fields: {
      title: 'Title',
      start: 'Start',
      end: 'End',
      categories: 'Categories',
    },
    validation: {
      title: 'Enter the internship title',
      start: 'Enter the start date',
      end: 'Enter the end date',
      categories: 'Choose at least one category',
      template: 'Choose a template',
      agreementTemplate: 'Choose an agreement template',
    },
    groups: {
      current: 'Internship groups',
      currentHint:
        "Untick a group to remove it from the internship — its students' placements are deleted. A locked group cannot be removed (an ended placement, a company supervisor, an agreement or survey answers).",
      locked: 'Cannot be removed',
      add: 'Add groups',
      year: 'Year',
      allYears: 'All years',
      search: 'Search',
      searchPlaceholder: 'Group title…',
      none: 'No groups',
      cut: 'Showing {{shown}} of {{total}} — refine the search',
      chosen: 'Keeping: {{keep}} · adding: {{add}}',
      saveHint:
        'Saving also adds the students of every ticked group who are not on this internship yet.',
    },
    templates: {
      currentProgram: 'Current program',
      currentQA: 'Current survey',
      pickProgram: 'New program',
      pickQA: 'New survey',
      none: 'none',
      placeholder: 'Choose a template',
      hintProgram:
        'The internship gets a copy of the chosen template. Interns whose placement ended before the edit window keep the current program; the rest move to the new one. Interns with a program of their own are not changed.',
      hintQA:
        'The internship gets a copy of the chosen template. Interns whose placement ended before the edit window keep the current survey (their answers stay); the rest move to the new one.',
    },
    agreementTemplate: {
      current: 'Current agreement number',
      pick: 'Agreement template',
      search: 'Search by title or prefix',
      none: 'No active agreement templates',
      hint: 'Only an active template can be chosen. Interns with a template of their own are not changed; existing agreements keep their numbers.',
    },
    confirm: {
      removeAgreementTemplate:
        'Remove the agreement template from the internship “{{title}}” (current agreement number: {{number}})? Agreements created from now on take their number from the internship’s agreement name. Existing agreements are not changed.',
      deleteAllRecords:
        'Delete ALL diary records of the internship “{{title}}”? The records of interns whose placement is still inside the edit window are deleted. Their progress is recalculated and the interns are notified. This cannot be undone.',
      deleteAllOrgAnswers:
        'Delete ALL company survey answers of the internship “{{title}}”? The answers of interns whose placement is still inside the edit window are deleted. The supervisors who answered and the interns are notified. This cannot be undone.',
    },
    messages: {
      updated: 'Internship saved',
      groupsSaved: 'Groups saved',
      programChanged: 'Program changed',
      qaChanged: 'Survey changed',
      agreementTemplateSet: 'Agreement template assigned',
      agreementTemplateRemoved: 'Agreement template removed',
      recordsDeleted: 'Records deleted: {{deleted}}, interns: {{interns}}',
      answersDeleted: 'Answers deleted: {{deleted}}, interns: {{interns}}',
      failed: 'Could not save',
      loadFailed: 'Could not load the data',
      downloadError: 'Could not download the file',
    },
    files: {
      downloadSummary: 'summary',
      downloadSupervisors: 'supervisors',
    },
    save: 'Save',
    delete: 'Delete',
    remove: 'Remove',
  },
}
